// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file branch/get_branches.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Branch } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetBranchesForCompanyRequest
 */
export class GetBranchesForCompanyRequest extends Message<GetBranchesForCompanyRequest> {
  /**
   * @generated from field: string company_code = 1;
   */
  companyCode = "";

  constructor(data?: PartialMessage<GetBranchesForCompanyRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetBranchesForCompanyRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "company_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBranchesForCompanyRequest {
    return new GetBranchesForCompanyRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBranchesForCompanyRequest {
    return new GetBranchesForCompanyRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBranchesForCompanyRequest {
    return new GetBranchesForCompanyRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBranchesForCompanyRequest | PlainMessage<GetBranchesForCompanyRequest> | undefined, b: GetBranchesForCompanyRequest | PlainMessage<GetBranchesForCompanyRequest> | undefined): boolean {
    return proto3.util.equals(GetBranchesForCompanyRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetBranchesForCompanyResponse
 */
export class GetBranchesForCompanyResponse extends Message<GetBranchesForCompanyResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.Branch branches = 1;
   */
  branches: Branch[] = [];

  constructor(data?: PartialMessage<GetBranchesForCompanyResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetBranchesForCompanyResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "branches", kind: "message", T: Branch, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBranchesForCompanyResponse {
    return new GetBranchesForCompanyResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBranchesForCompanyResponse {
    return new GetBranchesForCompanyResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBranchesForCompanyResponse {
    return new GetBranchesForCompanyResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBranchesForCompanyResponse | PlainMessage<GetBranchesForCompanyResponse> | undefined, b: GetBranchesForCompanyResponse | PlainMessage<GetBranchesForCompanyResponse> | undefined): boolean {
    return proto3.util.equals(GetBranchesForCompanyResponse, a, b);
  }
}

